// reducer.js
import { START_TRACE, STOP_TRACE } from './actionsTypes'

const initialState = {
  activeTraces: {},
  traces: {},
}

const traceReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case START_TRACE:
      return {
        ...state,
        activeTraces: {
          ...state.activeTraces,
          [payload.traceName]: true,
        },
        traces: {
          ...state.traces,
          [payload.traceName]: payload.trace,
        },
      }
    case STOP_TRACE:
      const traceToRemove = state.traces[payload]
      if (traceToRemove) {
        traceToRemove.stop()
      }
      const { [payload]: _, ...updatedTraces } = state.activeTraces
      return {
        ...state,
        activeTraces: updatedTraces,
      }
    default:
      return state
  }
}

export default traceReducer
